export default __webpack_public_path__ + "static/media/Badge8.3900772b.png";